import Loading from '../../../components/Loading';
import {sessionColumns} from './sessionColumns';
import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
// src/components/sesiones/SesionesGenerales.tsx
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ArrowLeft, Calendar, Clock, User, Banknote,
    Eye, Filter, Search, RefreshCw, FileText, FileSpreadsheet, CreditCard, ChevronRight, Home, X
} from 'lucide-react';
import {
    fetchSesionesPOS,
    SesionPOS,
    fetchReporteSesionPOS
} from '../../../services/pos/sesionPOSService';
import { fetchPuntosDeVenta, PuntoDeVenta } from '../../../services/pos/puntoDeVentaService';
import { generarPDFReporteSesionPOS } from '../../../utils/pdfReporteSesionPOS';
import { generarExcelReporteSesionPOS } from '../../../utils/excelReporteSesionPOS';

// ── Paleta de diseño Co Marca ─────────────────────────────
const colors = {
    primary:        'var(--ad-primary, #3564db)',
    primaryDark:    'var(--ad-primary-dark, #274f9d)',
    secondary:      'var(--ad-secondary, #3564db)',
    secondaryLight: 'var(--ad-secondary, #92b1ed)',
    accent:         '#FFD97A',
    accentDark:     '#EC8400',
};

const css = `

.ses-gen * { font-family:'DM Sans',sans-serif; box-sizing:border-box; }
@keyframes sesFadeUp { from{opacity:0;transform:translateY(16px);} to{opacity:1;transform:translateY(0);} }
@keyframes spin { to{transform:rotate(360deg);} }
.ses-fadeup   { animation:sesFadeUp .5s cubic-bezier(.16,1,.3,1) both; }
.ses-fadeup-1 { animation:sesFadeUp .5s .08s cubic-bezier(.16,1,.3,1) both; }

.ses-table-row { transition:background .12s; }
.ses-table-row:hover { background:var(--ad-soft, #fafcff); }

.ses-btn-view {
    display:inline-flex; align-items:center; gap:5px;
    padding:6px 12px; border-radius:8px; border:none; cursor:pointer;
    font-size:.78rem; font-weight:700; font-family:'DM Sans',sans-serif;
    background:color-mix(in srgb, ${colors.secondary} 7.06%, transparent); color:var(--ad-link, #2854c5);
    transition:all .2s;
}
.ses-btn-view:hover { background:${colors.secondary}; color:#fff; transform:translateY(-1px); }

.ses-btn-pdf {
    display:inline-flex; align-items:center; gap:5px;
    padding:6px 12px; border-radius:8px; border:none; cursor:pointer;
    font-size:.78rem; font-weight:700; font-family:'DM Sans',sans-serif;
    background:color-mix(in srgb, ${colors.secondaryLight} 7.06%, transparent); color:#065f46;
    transition:all .2s;
}
.ses-btn-pdf:hover:not(:disabled) { background:${colors.secondaryLight}; color:#fff; transform:translateY(-1px); }
.ses-btn-pdf:disabled { opacity:.5; cursor:not-allowed; }

.ses-btn-back {
    display:inline-flex; align-items:center; gap:7px;
    background:var(--ad-surface, #fff); border:1.5px solid var(--ad-line, #e2e8f0);
    color:var(--ad-ink, #374151); border-radius:11px;
    padding:9px 16px; font-size:.85rem; font-weight:700;
    cursor:pointer; transition:all .2s;
}
.ses-btn-back:hover { background:var(--ad-soft, #f8fafc); border-color:color-mix(in srgb, ${colors.secondary} 25.1%, transparent); color:var(--ad-link, #2854c5); }

.ses-btn-filter {
    display:inline-flex; align-items:center; gap:6px;
    padding:9px 16px; border-radius:11px; border:1.5px solid var(--ad-line, #e2e8f0);
    background:var(--ad-surface, #fff); color:var(--ad-ink, #374151); font-size:.85rem; font-weight:700;
    cursor:pointer; transition:all .2s; font-family:'DM Sans',sans-serif;
}
.ses-btn-filter:hover { background:var(--ad-soft, #f8fafc); border-color:color-mix(in srgb, ${colors.secondary} 25.1%, transparent); color:var(--ad-link, #2854c5); }

.ses-btn-clear {
    display:inline-flex; align-items:center; gap:6px;
    padding:9px 16px; border-radius:11px; border:1.5px solid var(--ad-line, #e2e8f0);
    background:var(--ad-soft, #f8fafc); color:var(--ad-ink, #374151); font-size:.85rem; font-weight:700;
    cursor:pointer; transition:all .2s; font-family:'DM Sans',sans-serif;
}
.ses-btn-clear:hover { background:var(--ad-line, #f1f5f9); }

.ses-input {
    width:100%; padding:10px 14px; border-radius:10px; border:1.5px solid var(--ad-line, #e5e7eb);
    background:#fafafa; font-size:.88rem; color:var(--ad-ink, #374151); outline:none;
    transition:all .2s; font-family:'DM Sans',sans-serif;
}
.ses-input:focus { border-color:${colors.secondary}; box-shadow:0 0 0 3px color-mix(in srgb, ${colors.secondary} 7.06%, transparent); background:var(--ad-surface, #fff); }

.ses-select {
    width:100%; padding:10px 14px; border-radius:10px; border:1.5px solid var(--ad-line, #e5e7eb);
    background:#fafafa; font-size:.88rem; color:var(--ad-ink, #374151); outline:none;
    transition:all .2s; font-family:'DM Sans',sans-serif;
    appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
    background-repeat:no-repeat; background-position:right 14px center;
}
.ses-select:focus { border-color:${colors.secondary}; box-shadow:0 0 0 3px color-mix(in srgb, ${colors.secondary} 7.06%, transparent); background:var(--ad-surface, #fff); }

.custom-scroll::-webkit-scrollbar { height:6px; width:6px; }
.custom-scroll::-webkit-scrollbar-track { background:transparent; }
.custom-scroll::-webkit-scrollbar-thumb { background:rgba(0,127,200,.3); border-radius:20px; }
.custom-scroll::-webkit-scrollbar-thumb:hover { background:rgba(0,127,200,.5); }
`;

interface FiltrosSesiones {
    punto_de_venta: string;
    usuario: string;
    estado: string;
    fecha_inicio: string;
    fecha_fin: string;
    buscar: string;
}

const SesionesPOSGeneral: React.FC = () => {
    const navigate = useNavigate();
    const [sesiones, setSesiones] = useState<SesionPOS[]>([]);
    const [puntosDeVenta, setPuntosDeVenta] = useState<PuntoDeVenta[]>([]);
    const [loading, setLoading] = useState(true);
    const [filtrosAbiertos, setFiltrosAbiertos] = useState(false);
    const [generandoPDF, setGenerandoPDF] = useState<number | null>(null);
    const [generandoExcel, setGenerandoExcel] = useState<number | null>(null);
    const [filtros, setFiltros] = useState<FiltrosSesiones>({
        punto_de_venta: '',
        usuario: '',
        estado: '',
        fecha_inicio: '',
        fecha_fin: '',
        buscar: ''
    });

    const [loadError,setLoadError]=useState('');
    const request=useRef(0);
    useEffect(()=>()=>{request.current+=1;},[]);

    // ── Helpers ──────────────────────────────────────────────
    const formatSaldo = (v: any) => {
        const n = Number(v);
        return isNaN(n) ? '0.00' : n.toFixed(2);
    };
    const formatDate = (d: string) => {
        if (!d) return 'N/A';
        return new Date(d).toLocaleDateString('es-ES', { year:'numeric', month:'short', day:'numeric' });
    };
    const formatTime = (d: string) => {
        if (!d) return 'N/A';
        return new Date(d).toLocaleTimeString('es-ES', { hour:'2-digit', minute:'2-digit' });
    };
    const getEstadoStyle = (estado: string) => {
        switch (estado) {
            case 'cerrada': return { bg:`color-mix(in srgb, ${colors.secondaryLight} 7.84%, transparent)`, border:`1px solid color-mix(in srgb, ${colors.secondaryLight} 18.82%, transparent)`, color:'var(--ad-success, #065f46)', dot:colors.secondaryLight };
            case 'abierta': return { bg:`color-mix(in srgb, ${colors.secondary} 7.06%, transparent)`, border:`1px solid color-mix(in srgb, ${colors.secondary} 14.51%, transparent)`, color:'var(--ad-link, #2854c5)', dot:colors.secondary };
            default:        return { bg:`color-mix(in srgb, ${colors.primary} 6.27%, transparent)`, border:`1px solid color-mix(in srgb, ${colors.primary} 13.33%, transparent)`, color:'var(--ad-link, #2854c5)', dot:colors.primary };
        }
    };

    const handleGenerarPDF = async (sesionId: number) => {
        setGenerandoPDF(sesionId);
        try {
            const data = await fetchReporteSesionPOS(sesionId);
            await generarPDFReporteSesionPOS(data);
        } catch { alert('Error al generar el reporte.'); }
        finally { setGenerandoPDF(null); }
    };

    const handleGenerarExcel = async (sesionId: number) => {
        setGenerandoExcel(sesionId);
        try {
            const data = await fetchReporteSesionPOS(sesionId);
            await generarExcelReporteSesionPOS(data);
        } catch { alert('Error al generar el reporte Excel.'); }
        finally { setGenerandoExcel(null); }
    };

    useEffect(() => {
        const generation=++request.current;
        setLoadError('');
        const cargarDatos = async () => {
            try {
                setLoading(true);
                const [sesionesData, puntosData] = await Promise.all([
                    fetchSesionesPOS(),
                    fetchPuntosDeVenta()
                ]);
                if(generation!==request.current)return;
                setSesiones(sesionesData);
                setPuntosDeVenta(puntosData);
            } catch (error) {
                if(generation===request.current)setLoadError('No se pudieron cargar las sesiones. Vuelve a intentarlo.');
            } finally { if(generation===request.current)setLoading(false); }
        };
        cargarDatos();
    }, []);

    const aplicarFiltros = async () => {
        const generation=++request.current;
        setLoadError('');
        const selected={...filtros};
        setLoading(true);

            try {
                let sesionesFiltradas = await fetchSesionesPOS();
                if (selected.punto_de_venta) {
                    sesionesFiltradas = sesionesFiltradas.filter(s => s.punto_de_venta.toString() === selected.punto_de_venta);
                }
                if (selected.estado) {
                    sesionesFiltradas = sesionesFiltradas.filter(s => s.estado === selected.estado);
                }
                if (selected.fecha_inicio) {
                    const fi = new Date(selected.fecha_inicio);
                    sesionesFiltradas = sesionesFiltradas.filter(s => new Date(s.fecha_apertura) >= fi);
                }
                if (selected.fecha_fin) {
                    const ff = new Date(selected.fecha_fin);
                    ff.setHours(23,59,59);
                    sesionesFiltradas = sesionesFiltradas.filter(s => new Date(s.fecha_apertura) <= ff);
                }
                if (selected.buscar) {
                    const t = selected.buscar.toLowerCase();
                    sesionesFiltradas = sesionesFiltradas.filter(s =>
                        s.usuario_nombre?.toLowerCase().includes(t) ||
                        s.punto_de_venta_nombre?.toLowerCase().includes(t) ||
                        s.observaciones_apertura.toLowerCase().includes(t) ||
                        s.observaciones_cierre.toLowerCase().includes(t)
                    );
                }
                if(generation===request.current)setSesiones(sesionesFiltradas);
            } catch (error) {
                if(generation===request.current)setLoadError('No se pudieron cargar las sesiones. Vuelve a intentarlo.');
            } finally { if(generation===request.current)setLoading(false); }

    };

    const limpiarFiltros = () => {
        const generation=++request.current;
        setLoadError('');
        setFiltros({ punto_de_venta:'', usuario:'', estado:'', fecha_inicio:'', fecha_fin:'', buscar:'' });
        setLoading(true);
        fetchSesionesPOS().then(data => { if(generation===request.current){setSesiones(data);setLoading(false);} }).catch(() => {if(generation===request.current){setLoading(false);setLoadError('No se pudieron cargar las sesiones. Vuelve a intentarlo.');}});
    };

    const handleFiltroChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));
    };

    if (loading && sesiones.length === 0) return (
        <Loading text="Cargando información…"/>
    );

    return <LumaResourceWorkspace title="Sesiones del punto de venta" description="Consulta y gestiona la información de tu coworking." group="Punto de venta" rows={sesiones} nameKey="codigo" statusKey="estado" columns={sessionColumns} extraActions={r=><><button type="button" onClick={()=>navigate(`/sesiones-pos/${r.id}`)}>Detalle de sesión</button><button type="button" onClick={()=>navigate(`/sesiones-pos/${r.id}/pagos`)}>Pagos</button><button type="button" disabled={generandoPDF===r.id} onClick={()=>handleGenerarPDF(r.id)}>PDF</button><button type="button" disabled={generandoExcel===r.id} onClick={()=>handleGenerarExcel(r.id)}>Excel</button></>}><div className="vx-metric-grid">{[{label:'Sesiones POS',value:sesiones.length,sub:'Sesiones consultadas'},{label:'Recaudación',value:lumaMoney(sesiones.reduce((n,r)=>n+Number(r.total_pagos||0),0)),sub:'Cobros registrados'},{label:'Diferencias',value:lumaMoney(sesiones.filter(r=>r.estado==='cerrada'&&r.saldo_final!==null).reduce((n,r)=>n+Number(r.saldo_final)-Number(r.saldo_actual),0)),sub:'Cierres de caja'}].map(m=><article className="vx-metric" key={m.label}><p>{m.label}</p><strong>{m.value}</strong><small>{m.sub}</small></article>)}</div>{loadError&&<p role="alert" className="luma-feedback">{loadError}</p>}<div className="luma-resource-toolbar"><button type="button" className="vx-button vx-button-secondary" onClick={()=>setFiltrosAbiertos(v=>!v)}>Filtros</button><button type="button" className="vx-button vx-button-secondary" onClick={limpiarFiltros}>Limpiar</button></div>                {filtrosAbiertos && (
                    <div className="ses-fadeup-1 card custom-card vx-card" style={{
                        background:'var(--ad-surface, #fff)', borderRadius:'16px', border:'1.5px solid var(--ad-line, #f1f5f9)',
                        padding:'20px', marginBottom:'20px', display:'grid',
                        gridTemplateColumns:'repeat(auto-fill, minmax(200px,1fr))', gap:'16px'
                    }}>
                        <div>
                            <label htmlFor="session-filter-punto_de_venta" style={{ fontSize:'.68rem', fontWeight:'650', color:'var(--ad-ink, #374151)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'7px', display:'block' }}>POS</label>
                            <select id="session-filter-punto_de_venta" name="punto_de_venta" value={filtros.punto_de_venta} onChange={handleFiltroChange} className="ses-select">
                                <option value="">Todos</option>
                                {puntosDeVenta.map(pos => <option key={pos.id} value={pos.id}>{pos.nombre}</option>)}
                            </select>
                        </div>
                        <div>
                            <label htmlFor="session-filter-estado" style={{ fontSize:'.68rem', fontWeight:'650', color:'var(--ad-ink, #374151)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'7px', display:'block' }}>Estado</label>
                            <select id="session-filter-estado" name="estado" value={filtros.estado} onChange={handleFiltroChange} className="ses-select">
                                <option value="">Todos</option>
                                <option value="abierta">Abierta</option>
                                <option value="cerrada">Cerrada</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="session-filter-fecha_inicio" style={{ fontSize:'.68rem', fontWeight:'650', color:'var(--ad-ink, #374151)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'7px', display:'block' }}>Desde</label>
                            <input type="date" id="session-filter-fecha_inicio" name="fecha_inicio" value={filtros.fecha_inicio} onChange={handleFiltroChange} className="ses-input" />
                        </div>
                        <div>
                            <label htmlFor="session-filter-fecha_fin" style={{ fontSize:'.68rem', fontWeight:'650', color:'var(--ad-ink, #374151)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'7px', display:'block' }}>Hasta</label>
                            <input type="date" id="session-filter-fecha_fin" name="fecha_fin" value={filtros.fecha_fin} onChange={handleFiltroChange} className="ses-input" />
                        </div>
                        <div>
                            <label htmlFor="session-filter-buscar" style={{ fontSize:'.68rem', fontWeight:'650', color:'var(--ad-ink, #374151)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'7px', display:'block' }}>Buscar</label>
                            <div style={{ position:'relative' }}>
                                <Search size={13} color="var(--ad-muted, #94a3b8)" style={{ position:'absolute', left:'10px', top:'50%', transform:'translateY(-50%)' }}/>
                                <input type="text" id="session-filter-buscar" name="buscar" value={filtros.buscar} onChange={handleFiltroChange} placeholder="Usuario, POS..." className="ses-input" style={{ paddingLeft:'32px' }}/>
                            </div>
                        </div>
                        <div style={{ display:'flex', alignItems:'flex-end', gap:'8px' }}>
                            <button onClick={aplicarFiltros} style={{
                                display:'inline-flex', alignItems:'center', gap:'6px', padding:'9px 16px', borderRadius:'11px',
                                border:'none', background:`linear-gradient(135deg,${colors.secondary},#004d7a)`, color:'#fff',
                                fontSize:'.85rem', fontWeight:'700', cursor:'pointer', transition:'all .2s'
                            }}>
                                <Search size={14}/> Aplicar
                            </button>
                            <button onClick={() => setFiltrosAbiertos(false)} style={{
                                padding:'9px 14px', borderRadius:'11px', border:'1.5px solid var(--ad-line, #e2e8f0)', background:'var(--ad-surface, #fff)',
                                color:'var(--ad-muted, #64748b)', cursor:'pointer'
                            }}><X size={14}/></button>
                        </div>
                    </div>
                )}

</LumaResourceWorkspace>;
};
export default SesionesPOSGeneral;
